import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Events = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M4.584,48A4.589,4.589,0,0,1,0,43.416V7.6A4.589,4.589,0,0,1,4.584,3.018H7.169v-1.6a1.417,1.417,0,0,1,2.835,0v1.6h2.785v-1.6a1.417,1.417,0,0,1,2.835,0v1.6h15.65v-1.6a1.417,1.417,0,0,1,2.835,0v1.6h2.785v-1.6a1.417,1.417,0,0,1,2.834,0v1.6h2.585A4.589,4.589,0,0,1,46.9,7.6V43.416A4.589,4.589,0,0,1,42.314,48ZM2.834,43.417a1.751,1.751,0,0,0,1.749,1.749h37.73a1.751,1.751,0,0,0,1.749-1.749V14.8H2.834Zm0-35.815v4.366H44.063V7.6a1.751,1.751,0,0,0-1.749-1.749H39.729v1.6a1.417,1.417,0,0,1-2.835,0v-1.6H34.109v1.6a1.417,1.417,0,0,1-2.835,0v-1.6H15.624v1.6a1.417,1.417,0,0,1-2.835,0v-1.6H10v1.6a1.417,1.417,0,0,1-2.835,0v-1.6H4.584A1.751,1.751,0,0,0,2.834,7.6ZM12.2,29.984A11.251,11.251,0,1,1,23.449,41.235,11.264,11.264,0,0,1,12.2,29.984Zm2.834,0a8.417,8.417,0,1,0,8.417-8.417A8.427,8.427,0,0,0,15.032,29.984Zm6.311,3.532L18.49,30.664a1.418,1.418,0,1,1,2-2l1.85,1.85L26.4,26.452a1.417,1.417,0,0,1,2,2l-5.06,5.06a1.418,1.418,0,0,1-2,0Z" fill={fill} />
    </svg>
  );
};

Events.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Events.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};